import React from 'react';

import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';

import { openProjectsMenu } from 'src/redux/jira/actions';
import urls from 'src/urls/jira';
import { publishUiEvent } from 'src/utils/analytics/publish';

import { SCREEN_NAME } from '../../constants';

import messages from './empty-state-no-relevant-projects.i18n';
import * as styles from './empty-state-no-relevant-projects.styled';
import issuesListPreviewImgUrl from './issues-list-preview.png';
import linkingOptionsSvg from './linking-options.svg';

const NoRelevantProjectsEmptyState = () => {
  const dispatch = useDispatch();

  const handleManageProjectsDialogLinkClick = () => {
    publishUiEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'projectManagementLink',
      source: SCREEN_NAME,
    });

    dispatch(openProjectsMenu());
  };

  const handleLearnMoreLinkClick = () => {
    publishUiEvent({
      action: 'clicked',
      actionSubject: 'link',
      actionSubjectId: 'noRelevantProjectsLearnMoreLinkButton',
      source: SCREEN_NAME,
    });
  };

  const manageProjectsDialogLink = (
    <styles.ManageProjectsButton
      appearance="link"
      onClick={handleManageProjectsDialogLinkClick}
    >
      <FormattedMessage {...messages.manageProjectsDialogLinkText} />
    </styles.ManageProjectsButton>
  );

  return (
    <styles.EmptyStateWrapper>
      <h3>
        <FormattedMessage {...messages.header} />
      </h3>
      <styles.Description>
        <FormattedMessage {...messages.description} />
      </styles.Description>
      <styles.HighlightItems>
        <styles.HighlightItem>
          <styles.LinkOptionsImage src={linkingOptionsSvg} />
          <FormattedMessage
            {...messages.linkingOptionsText}
            values={{ lineBreak: <br />, manageProjectsDialogLink }}
          />
        </styles.HighlightItem>
        <styles.HighlightItem>
          <styles.IssuesListImage src={issuesListPreviewImgUrl} />
          <FormattedMessage {...messages.issuesListPreviewText} />
        </styles.HighlightItem>
      </styles.HighlightItems>

      <CustomThemeButton
        href={urls.external.docsUseJiraProjects}
        appearance="link"
        label="learnMore"
        target="_blank"
        onClick={handleLearnMoreLinkClick}
      >
        <FormattedMessage {...messages.learnMoreLinkLabel} />
      </CustomThemeButton>
    </styles.EmptyStateWrapper>
  );
};

export default NoRelevantProjectsEmptyState;
